<template>
    <div>
        <div class='contribution-reply-comment'>
            <span class='contribution-reply-comment-name' v-html="associated_with"></span>
            <br />
            <span class='contribution-reply-comment-date' v-text="created_at"></span>
            <div class='contribution-reply-comment-detail'>
                <div class='container-reply-comment' v-html="comment" v-if="!edit"></div>
                <form-component
                    v-if="edit"
                    :send_text="save_text"
                    :cancel_text="cancel_text"
                    :id_element="id_comment"
                    :save_url="edit_url"
                    :comment="comment"
                    v-on:cancel="changeEditStatus(false)"
                    v-on:saved="saved($event)"
                    :terms_text="terms_text"
                    :accept_terms_text="accept_terms_text"
                ></form-component>
            </div>
            <div class='option-replay-comments' v-if="can_edit && !edit">
                <div class="relative-position options-forum">
                    <span class="pull-left">
                        <span v-text="status_text"></span>:
                        <span v-bind:class="[status ? 'contribution-status-approved' : 'contribution-status-unapproved']" v-text="status ? status_active_text : status_suspended_text"></span>
                    </span>
                    <span class="pull-right">
                        <i class='fa fa-pencil-square edit_btn' v-bind:title='edit_text' v-on:click="changeEditStatus(true)"></i>
                        <i class='fa fa-times del_com_rev' v-bind:title='delete_text' v-on:click="onDelete"></i>
                    </span>
                </div>
                <div class="clearfix"></div>
            </div>
        </div>
    </div>
</template>

<script>
    import FormComment from './FormComment.vue';
    export default {
        components: {
            'form-component': FormComment
        },
        props: [
            'associated_with', 'created_at', 'comment', 'can_edit', 'edit_text', 'delete_text', 'save_text',
            'cancel_text', 'edit_url', 'id_comment', 'status', 'status_text', 'status_active_text',
            'status_suspended_text', 'terms_text', 'accept_terms_text'
        ],
        data: function () {
            return {
                edit: false
            }
        },
        methods: {
            changeEditStatus: function (status) {
                this.edit = status;
            },
            saved: function (comment) {
                this.changeEditStatus(false);
                this.comment = comment.comment;
                this.status  = true;
            },
            onDelete: function () {
                this.$emit('on_delete', true);
            }
        }
    }
</script>
